import { InputHTMLAttributes } from 'react';

import { Alignment } from '../../../models/Alignment';
import { CustomField } from '../../../models/types/CustomField';
import { CustomFieldLabel } from '../../../models/types/CustomFieldLabel';
import BaseInput from '../BaseInput/BaseInput';
import { FieldLabel, FieldWrapper } from '../Field/Field';
import { useInput } from './input.hooks';

export interface IInputProps
  extends InputHTMLAttributes<HTMLInputElement>,
    CustomField,
    CustomFieldLabel {
  alignment?: Alignment;
  charsBeforeValue?: string;
  onlyNumber?: boolean;
  name?: string;
  placeholder?: string;
  id?: string;
}

export const Input = ({
  alignment = 'left',
  className,
  disabled,
  isLabelHidden,
  labelAnimation,
  label,
  ...props
}: IInputProps) => {
  const { onChangeHandler, currentValue } = useInput(props);

  return (
    <FieldWrapper className={className}>
      <BaseInput
        {...props}
        onChange={onChangeHandler}
        disabled={disabled}
        value={currentValue}
      />
      {!isLabelHidden && (
        <FieldLabel disabled={disabled} autoLabelAnimation={labelAnimation}>
          {label}
        </FieldLabel>
      )}
    </FieldWrapper>
  );
};
